export function transformAutomatedWelcomeEmails(value: boolean): boolean {
  return !value;
}
